// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gmat","title":"styles_title__u6AeK"};